import { render, staticRenderFns } from "./embedLayout.vue?vue&type=template&id=7471e77e&scoped=true&"
import script from "./embedLayout.vue?vue&type=script&lang=js&"
export * from "./embedLayout.vue?vue&type=script&lang=js&"
import style0 from "./embedLayout.vue?vue&type=style&index=0&id=7471e77e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7471e77e",
  null
  
)

export default component.exports